var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"navigation-footer"},[_c('div',{staticClass:"navigation-footer__bottom"},[_c('p',[_vm._v(_vm._s(_vm.currentYear)+" © Centre Qigong Laflamme")]),_c('p',[_vm._v("Français / English")])])])}
var staticRenderFns = []

export { render, staticRenderFns }